import { useAtomValue } from 'jotai';
import maplibregl from 'maplibre-gl';
import { useEffect, useState } from 'react';
import { useMap } from '@/features/map';
import { unitsAtom } from './unitsAtom';

/** MapLibre scale bar following the selected unit system. */
export function MapScale() {
  const map = useMap();
  const units = useAtomValue(unitsAtom);
  const [control] = useState(() => new maplibregl.ScaleControl());

  useEffect(() => {
    if (!map) return;
    map.addControl(control, 'bottom-left');
    return () => void map.removeControl(control);
  }, [map, control]);

  useEffect(() => {
    if (map) control.setUnit(units); // only valid once the control is on the map
  }, [map, control, units]);

  return null;
}
